// Espelha TaskStatus::DEFAULT_STATUSES do backend (app/models/task_status.rb).
// Conta sem catalogo semeado ainda precisa de colunas no Quadro, entao o
// front cai neste catalogo padrao em vez de renderizar zero coluna.
export const DEFAULT_TASK_STATUSES = [
  {
    key: 'pending',
    label: 'Pendente',
    color: '#94a3b8',
    position: 0,
    is_terminal: false,
  },
  {
    key: 'in_progress',
    label: 'Em andamento',
    color: '#3b82f6',
    position: 1,
    is_terminal: false,
  },
  {
    key: 'done',
    label: 'Feito',
    color: '#10b981',
    position: 2,
    is_terminal: true,
  },
  {
    key: 'cancelled',
    label: 'Cancelado',
    color: '#ef4444',
    position: 3,
    is_terminal: true,
  },
];

export const withDefaultStatuses = statuses =>
  statuses && statuses.length
    ? statuses
    : DEFAULT_TASK_STATUSES.map(status => ({ ...status }));
